/* global google */
import * as React from "react"
import fieldProps from "./fieldProps";
import apiClient from '../../../../services/axios'
import {getUrl} from '../../../../services/api'
// import axios from "axios";

class AutocompleteCity extends React.Component{

  componentDidMount(){
    const {types=['(cities)'], country="it"} = this.props;
    const optionsAutocomplet = {
      language: 'it-IT',
      types
    }
    if(country){
      // optionsAutocomplet.componentRestrictions = { country }
    }
    this.autocomplete = new google.maps.places.Autocomplete(this.input, optionsAutocomplet)
    this.autocomplete.addListener('place_changed', this._fillInAddress)
    /* field.blur( () => {
      if(field.val().trim()==""){
        onChange(null)
      }
    }); */
  }

  _onBlur = () => {
    const { onChange } = this.props
    if (this.input.value.trim() === '') {
      onChange(null)
    }
  }

  _fillInAddress = () => {
    const {onChange, itDetails} = this.props;
    const place = this.autocomplete.getPlace();
    // eslint-disable-next-line no-unused-vars
    let city = null;
    let prov = null;
    let country_code = null;
    let country = null;
    let city_long = null;
    let postal_code = null;

    const results =  place.address_components  || null
    if(results){
      city = place.address_components[0] && place.address_components[0].short_name || ''
      city_long = place.address_components[0] && place.address_components[0].long_name || ''
      results.forEach(item => {
        const comp = item
        if(comp.types.indexOf("administrative_area_level_2") >= 0){
          prov  =  comp.short_name || ""
        }else if(comp.types.indexOf("country") >= 0){
          country_code  =  comp.short_name || ""
          country = comp.long_name || ""
        }else if (comp.types.indexOf('postal_code') >= 0 ) {
          postal_code =  comp.long_name
        }
      })

      const values = {
        code: null,
        country,
        countryCode: country_code,
        label: city_long,
        prov,
        cap: postal_code,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }

      onChange(values)

      if(itDetails && country_code === "IT" ){
        apiClient.get(getUrl("api/city-details"),{ params: {cityLong:city_long,label:city,prov, postal_code} }).then(({data})=>{
          if(data){
            const {code,id_regione, provincia, cap} =  data
            onChange({
              ...values,
              code,
              region: id_regione,
              prov: provincia,
              cap
            });
          }
        })
      }
    }

  }

  render() {
    const {value ,onChange ,name } = this.props

    return (
      <input
        name={name}
        onBlur={this._onBlur}
        className={"form-control input-sm"}
        onChange={(e)=>onChange({label:e.target.value})}
        value={value}
        ref={(input)=> {this.input = input}}
      />
    )
  }

}

export default fieldProps(AutocompleteCity)
